import { Injectable } from '@angular/core';
import { HttpRequestService } from './http-request.service';
import { AuthService } from 'src/app/auth/auth.service';


@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(private httpService: HttpRequestService,
              private authService: AuthService
             ) { }
  
    logApiCount(screenName, serviceName, apiName) {
     /* const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
      const requestData = {
        'workFlowName': 'CoreRequestService',
        'processType': 'Screen',
        'workFlowParams': JSON.stringify({
          'methodName': 'gmapHitCount',
          'strToken': this.authService.getAuthorizationToken(), //currentUser.strToken,
          'strUserId': this.authService.getLoggedUserName(), //currentUser.USER_NAME,
          'strServiceName': serviceName,
          'strScreen': screenName,
          'strSource': 'MAN',
          'strAPIName': apiName,
        })
      };
      this.httpService.configRequestDataWithHeaders(requestData, 'post', '', true)
        .subscribe((response: any) => {
        }); */
    }
}
